import React, { useState } from 'react';
import { FormGroup, ModalBody, ModalHeader, Input, FormText } from 'reactstrap';
import './EditRetainerFeeModal.scss';
import Rodal from '../../../../../components/Rodal/Rodal';
import ButtonLoader from '../../../../../components/Layout/Buttons/ButtonLoader';
import { CurrencyInput, Form } from '@availity/form';

export interface EditRetainerFeeModalProps {
    isVisible: boolean;
    setIsVisible: (isVisible: boolean) => void;
    currentAmount: number | null;
    onSave: (amount: number, reason: string) => void;
    isSaving: boolean;
}

const EditRetainerFeeModal = (props: EditRetainerFeeModalProps) => {
    const [amount, setAmount] = useState(props.currentAmount ?? 0);
    const [reason, setReason] = useState('');
    const [isAmountError, setIsAmountError] = useState(false);
    const [isReasonError, setIsReasonError] = useState(false);

    const handleSave = () => {
        let hasErrors = false;

        if (amount == null || amount <= 0) {
            setIsAmountError(true);
            hasErrors = true;
        } else {
            setIsAmountError(false);
        }

        if (!reason || reason.trim() === '') {
            setIsReasonError(true);
            hasErrors = true;
        } else {
            setIsReasonError(false);
        }

        if (hasErrors) {
            return;
        }

        props.onSave(amount, reason.trim());
    };

    return (
        <Rodal
            visible={props.isVisible}
            onClose={() => {
                props.setIsVisible(false);
            }}
            animation={'fade'}
            showMask={false}
            width={500}
            className="edit-retainer-fee-modal-rodal"
            center>
            <div className="edit-retainer-fee-modal">
                <ModalHeader>Edit Monthly Retainer Fees</ModalHeader>
                <ModalBody>
                    <FormGroup className="retainer-fee-amount-form-group">
                        <div className="form-field-container">
                            <div className="mobile-label">
                                <label className="copy-name-label">Monthly Retainer Fees:</label>
                            </div>
                            <div className="mobile-input">
                                <Form
                                    onSubmit={() => { }}
                                    initialValues={{
                                        retainerFeeAmount: amount != null ? amount.toString() : '',
                                    }}>
                                    <CurrencyInput
                                        name="retainerFeeAmount"
                                        id="retainerFeeAmount"
                                        value={amount != null ? amount.toString() : ''}
                                        allowDecimals={true}
                                        allowNegativeValue={false}
                                        prefix="$"
                                        onValueChanged={(value) => {
                                            if (value === '' || value == null) {
                                                setAmount(0);
                                                return;
                                            }
                                            const numValue = parseFloat(value);
                                            if (isNaN(numValue)) {
                                                return;
                                            }
                                            setAmount(numValue);
                                            if (numValue > 0) {
                                                setIsAmountError(false);
                                            }
                                        }}
                                        className={isAmountError ? 'av-invalid is-invalid' : ''}
                                    />
                                </Form>
                            </div>
                        </div>
                        {isAmountError && (
                            <FormText color="danger" className="mt-1">
                                Amount must be greater than 0
                            </FormText>
                        )}
                    </FormGroup>

                    <FormGroup>
                        <label className="copy-name-label reason">Reason:</label>
                        <Input
                            type="textarea"
                            name="reason"
                            id="retainerFeeReason"
                            rows={4}
                            value={reason}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setReason(e.target.value);
                                if (e.target.value.trim() !== '') {
                                    setIsReasonError(false);
                                }
                            }}
                            className={isReasonError ? 'av-invalid is-invalid' : ''}
                            placeholder="Enter reason for changing monthly retainer fees"
                        />
                        {isReasonError && (
                            <FormText color="danger" className="mt-1">
                                Reason is required
                            </FormText>
                        )}
                    </FormGroup>
                    <div className="mt-auto d-flex justify-content-end modal-copy-buttons">
                        <button
                            type="button"
                            className="btn btn-cancel"
                            onClick={() => {
                                props.setIsVisible(false);
                            }}>
                            Cancel
                        </button>
                        <ButtonLoader
                            buttonText={'Save'}
                            disabled={amount == null || amount <= 0 || !reason || reason.trim() === ''}
                            isLoading={props.isSaving}
                            onClick={handleSave}
                            className={props.isSaving ? 'btn btn-primary loader-submit' : 'btn btn-primary'}
                            loaderButtonText={undefined}></ButtonLoader>
                    </div>
                </ModalBody>
            </div>
        </Rodal>
    );
};

export default EditRetainerFeeModal;
